/**
 * Created by fworld on 2019/10/17.
 */
import request from '@/util/request'
import ykRequest from '@/util/yk_request'

export const payAliCreate = (data) => {
    return request({
        url: '/api/v1/delivery/pay/aliCreate',
        method: 'post',
        data
    })
}

export const payWxCreate = (data) => {
    return request({
        url: '/api/v1/delivery/pay/wxCreate',
        method: 'post',
        data
    })
}

export const payAliUpdate = (data) => {
    return request({
        url: '/api/v1/delivery/pay/aliUpdate',
        method: 'post',
        data
    })
}

export const payWxUpdate = (data) => {
    return request({
        url: '/api/v1/delivery/pay/wxUpdate',
        method: 'post',
        data
    })
}

export const payAliDetail = (params) => {
    return request({
        url: '/api/v1/delivery/pay/aliDetail',
        method: 'get',
        params
    })
}

export const payWxDetail = (params) => {
    return request({
        url: '/api/v1/delivery/pay/wxDetail',
        method: 'get',
        params
    })
}

export const payUnion = (params) => {
    return request({
        url: '/api/v1/delivery/pay/union',
        method: 'get',
        params
    })
}

export const payList = (params) => {
    return request({
        url: '/api/v1/delivery/pay/list',
        method: 'get',
        params
    })
}


export const payBindDevice = (data) => {
    return request({
        url: '/api/v1/delivery/pay/bind/device',
        method: 'post',
        data
    })
}

export const payDeviceUnion = (params) => {
    return request({
        url: '/api/v1/delivery/pay/device/union',
        method: 'get',
        params
    })
}

export const payDeviceList = (params) => {
    return request({
        url: '/api/v1/delivery/pay/device/list',
        method: 'get',
        params
    })
}

export const payDeviceUnbind = (params) => {
    return request({
        url: '/api/v1/delivery/pay/device/unbind',
        method: 'get',
        params
    })
}


export const payWxRefund = (data) => {
    return request({
        url: "/api/v1/delivery/pay/wx/refund",
        method: 'post',
        data
    })
}

export const payAliRefund = (data) => {
    return request({
        url: "/api/v1/delivery/pay/ali/refund",
        method: 'post',
        data
    })
}


export const payAliApply = (data) => {
  return request({
    url: "/api/v1/delivery/pay/ali/apply",
    method: 'post',
    data
  })
}

export const payWxApply = (data) => {
  return request({
    url: '/api/v1/delivery/pay/wx/apply',
    method: 'post',
    data
  })
}

export const payWxBank = (name) => {
  return ykRequest({
    url: `/api/v1/collection/quick/pay/wx/banks?name=${name}`,
    method: 'get',
  })
}

export const payWxDelete = (uuid) => {
  return request({
    url: `/api/v1/delivery/pay/delete?uuid=${uuid}`,
    method: 'get',
  })
}

export const payWxResourceStatus = (uuid) => {
  return request({
    url: `/api/v1/delivery/pay/wx/resource/status?uuid=${uuid}`,
    method: 'get',
  })
}

export const payWxResourceInfo = (uuid) => {
  return request({
    url: `/api/v1/delivery/pay/wx/resource/info?uuid=${uuid}`,
    method: 'get',
  })
}



export const payUpdateName = (data) => {
  return request({
    url: `/api/v1/delivery/pay/rename`,
    method: 'post',
    data
  })
}
